<template>
  <div class="footer_wrap">
    <div class="main-container footer">
      <span>版权所有：黄冈师范学院体育场馆中心</span>
      <span>电话：029-8888888</span>
      <span>邮箱：XXXXXXXX@163.com</span>
    </div>
  </div>
</template>
<script>
  export default {
    data () {
      return {}
    },
    components: {}
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/BottomFooter.vue